<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br />
                        <a href="/card" class="link">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5><i class="bi bi-star-fill"></i>カードの変更</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="padding-top:70px;">
                <br>
                <div class="row justify-content-center">
                    <div class="col-8">
                        <img src="/images/Group13178.png" class="img-fluid">
                    </div>
                </div>
                <div class="row align-items-center" v-for="card in my_cards" :key="card.id" style="padding-bottom:10px;">
                    <div class="col-1 text-center">
                        <a @click="card.is_bookmark = isBookmark()" v-if="card.is_bookmark == 0"><i class="bi bi-star-fill"
                                style="font-size:23px;color:#e6e6e6;"></i></a>
                        <a @click="card.is_bookmark = 0, bookmark_count--" v-else><i class="bi bi-star-fill"
                                style="font-size:23px;color:#6b4eff;"></i></a>
                    </div>
                    <div class="col-2">
                        <img :src="card.thumbnail_image" class="rounded img-fluid">
                    </div>
                    <div class="col text-truncate">
                        {{ card.name }}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <br>
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna"
                                style="padding:13px 0;border:0;font-size:14px;font-size:16px;" @click="setBookmark()">
                                保存
                            </button>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            my_cards: [],
            bookmark_count: 0,
        };
    },
    methods: {
        isBookmark() {
            if (this.bookmark_count < 3) {
                this.bookmark_count++
                return 1
            }
            else {
                return 0
            }
        },
        async fetchMyCard() {
            await axios.get("/api/card/myall")
                .then((response) => {
                    this.my_cards = response.data.my_cards
                    this.bookmark_count = this.bookmark_count + response.data.card_member_count
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました");
                    }
                })
        },
        async setBookmark() {
            await axios.post("/api/card/bookmark/set", {
                my_cards: this.my_cards,
            })
                .then((response) => {
                    window.location.href = "/card"
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("保存に失敗しました");
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchMyCard()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました");

                    })
            }
            else {
                this.fetchMyCard()
            }
        }
        else {
            this.fetchMyCard()
        }
    },
};
</script>
<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
